/** Normalizes a label to a stable kebab-case tab slug (strips parentheses). */
export function normalizeTabSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[()]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function listPageTabTestIdentifier(
  pagePrefix: string,
  tabValue: string
): string {
  const slug =
    tabValue === 'all' ? 'all' : normalizeTabSlug(tabValue);
  return `${pagePrefix}-tab-${slug}`;
}

export function listPageTableHeaderTestId(
  pagePrefix: string,
  columnKey: string
): string {
  return `${pagePrefix}-table-header-${columnKey}`;
}

/** Documents table column header id (LOYALCM-3260). */
export function documentsTableHeaderTestId(columnKey: string): string {
  return listPageTableHeaderTestId('documents', columnKey);
}

/** Membership benefit/feature list row id from slug (LOYALCM-3256). */
export function membershipItemTestId(slug: string): string {
  return `membership-item-${slug}`;
}

/** `id`, `name`, and `data-testid` for native HTML elements (company profile labels/values). */
export function nativeTestAttrs(testId: string) {
  return {
    id: testId,
    name: testId,
    'data-testid': testId
  } as const;
}
